import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M20 2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zM9.36 6.99S6 6.91 6 7.02c-.02.26.79.57.79.57.11.08.13.25.04.36-.21.24-.56.65-.86.98-.27.31-.26.78.03 1.08l.01.02c.26.28.67.33.99.12l1-.65v3.99l-.83 1.46c-.21-.15-.41-.3-.6-.46-.3-.25-.74-.23-1.01.04l-.0706.0816c-.234.3134-.1919.7717.1106 1.0284 1.79 1.52 4.03 2.35 6.4 2.35s4.61-.83 6.41-2.35c.33-.29.35-.8.04-1.11l-.0882-.0735c-.2765-.1978-.6518-.1915-.9218.0335-.2.16-.4.31-.6.46L16 13.49v-2.5h.49c.28 0 .5-.22.5-.5l-.008-.0909c-.0416-.2353-.2431-.4091-.492-.4091h-4.83c-.18 0-.34-.1-.43-.25l-1.44-2.5c-.09-.15-.25-.25-.43-.25zm5.33 7.25l.81 1.41.03.06c-1.1.51-2.3.79-3.55.79s-2.43-.27-3.53-.79l.03-.06.81-1.41c1.74.65 3.66.65 5.4 0z"
  }],
  circles: []
};
var BedroomBabyIcon = function BedroomBabyIcon(props) {
  return renderIcon(props, iconType);
};
export { BedroomBabyIcon };